import React from 'react';
import {Navigate} from 'react-router-dom';
import _ from 'lodash';

import Forbidden from '@/page/component/AuthRoute/Forbidden';
import {useMenuService} from './adminService';

/**
 * 用于 /admin 的跳转。
 *
 * @constructor
 */
export default function AdminRedirect() {
    const menus = useMenuService();

    if (_.isEmpty(menus)) {
        return <Forbidden />;
    }

    // 存在菜单项则跳转
    return <Navigate to={menus[0].path} replace />;
}
